import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    enterRes: null,
    getByOrderRes: null,
    getByPatientRes: null,
    getTestHistoryRes: null,
    techValidateRes: null,
    batchTechValidateRes: null,
    authorizeRes: null,
    batchAuthorizeRes: null,
    amendRes: null,
    criticalNotifyRes: null,
    confirmContactRes: null,
};

const slice = createSlice({
    name: 'labResult',
    initialState,
    reducers: {
        enterLabResultRequest: (state) => { state.loading = true; },
        enterLabResultSuccess: (state, action) => { state.loading = false; state.enterRes = action.payload; },
        enterLabResultFailure: (state, action) => { state.loading = false; state.enterRes = action.payload; },
        resetEnterLabResult: (state) => { state.enterRes = null; },

        getLabResultByOrderRequest: (state) => { state.loading = true; },
        getLabResultByOrderSuccess: (state, action) => { state.loading = false; state.getByOrderRes = action.payload; },
        getLabResultByOrderFailure: (state, action) => { state.loading = false; state.getByOrderRes = action.payload; },
        resetGetLabResultByOrder: (state) => { state.getByOrderRes = null; },

        getLabResultByPatientRequest: (state) => { state.loading = true; },
        getLabResultByPatientSuccess: (state, action) => { state.loading = false; state.getByPatientRes = action.payload; },
        getLabResultByPatientFailure: (state, action) => { state.loading = false; state.getByPatientRes = action.payload; },
        resetGetLabResultByPatient: (state) => { state.getByPatientRes = null; },

        getLabResultTestHistoryRequest: (state) => { state.loading = true; },
        getLabResultTestHistorySuccess: (state, action) => { state.loading = false; state.getTestHistoryRes = action.payload; },
        getLabResultTestHistoryFailure: (state, action) => { state.loading = false; state.getTestHistoryRes = action.payload; },
        resetGetLabResultTestHistory: (state) => { state.getTestHistoryRes = null; },

        techValidateLabResultRequest: (state) => { state.loading = true; },
        techValidateLabResultSuccess: (state, action) => { state.loading = false; state.techValidateRes = action.payload; },
        techValidateLabResultFailure: (state, action) => { state.loading = false; state.techValidateRes = action.payload; },
        resetTechValidateLabResult: (state) => { state.techValidateRes = null; },

        batchTechValidateLabResultRequest: (state) => { state.loading = true; },
        batchTechValidateLabResultSuccess: (state, action) => { state.loading = false; state.batchTechValidateRes = action.payload; },
        batchTechValidateLabResultFailure: (state, action) => { state.loading = false; state.batchTechValidateRes = action.payload; },
        resetBatchTechValidateLabResult: (state) => { state.batchTechValidateRes = null; },

        authorizeLabResultRequest: (state) => { state.loading = true; },
        authorizeLabResultSuccess: (state, action) => { state.loading = false; state.authorizeRes = action.payload; },
        authorizeLabResultFailure: (state, action) => { state.loading = false; state.authorizeRes = action.payload; },
        resetAuthorizeLabResult: (state) => { state.authorizeRes = null; },

        batchAuthorizeLabResultRequest: (state) => { state.loading = true; },
        batchAuthorizeLabResultSuccess: (state, action) => { state.loading = false; state.batchAuthorizeRes = action.payload; },
        batchAuthorizeLabResultFailure: (state, action) => { state.loading = false; state.batchAuthorizeRes = action.payload; },
        resetBatchAuthorizeLabResult: (state) => { state.batchAuthorizeRes = null; },

        amendLabResultRequest: (state) => { state.loading = true; },
        amendLabResultSuccess: (state, action) => { state.loading = false; state.amendRes = action.payload; },
        amendLabResultFailure: (state, action) => { state.loading = false; state.amendRes = action.payload; },
        resetAmendLabResult: (state) => { state.amendRes = null; },

        criticalNotifyLabResultRequest: (state) => { state.loading = true; },
        criticalNotifyLabResultSuccess: (state, action) => { state.loading = false; state.criticalNotifyRes = action.payload; },
        criticalNotifyLabResultFailure: (state, action) => { state.loading = false; state.criticalNotifyRes = action.payload; },
        resetCriticalNotifyLabResult: (state) => { state.criticalNotifyRes = null; },

        confirmContactLabResultRequest: (state) => { state.loading = true; },
        confirmContactLabResultSuccess: (state, action) => { state.loading = false; state.confirmContactRes = action.payload; },
        confirmContactLabResultFailure: (state, action) => { state.loading = false; state.confirmContactRes = action.payload; },
        resetConfirmContactLabResult: (state) => { state.confirmContactRes = null; },
    }
});

export const {
    enterLabResultRequest, enterLabResultSuccess, enterLabResultFailure, resetEnterLabResult,
    getLabResultByOrderRequest, getLabResultByOrderSuccess, getLabResultByOrderFailure, resetGetLabResultByOrder,
    getLabResultByPatientRequest, getLabResultByPatientSuccess, getLabResultByPatientFailure, resetGetLabResultByPatient,
    getLabResultTestHistoryRequest, getLabResultTestHistorySuccess, getLabResultTestHistoryFailure, resetGetLabResultTestHistory,
    techValidateLabResultRequest, techValidateLabResultSuccess, techValidateLabResultFailure, resetTechValidateLabResult,
    batchTechValidateLabResultRequest, batchTechValidateLabResultSuccess, batchTechValidateLabResultFailure, resetBatchTechValidateLabResult,
    authorizeLabResultRequest, authorizeLabResultSuccess, authorizeLabResultFailure, resetAuthorizeLabResult,
    batchAuthorizeLabResultRequest, batchAuthorizeLabResultSuccess, batchAuthorizeLabResultFailure, resetBatchAuthorizeLabResult,
    amendLabResultRequest, amendLabResultSuccess, amendLabResultFailure, resetAmendLabResult,
    criticalNotifyLabResultRequest, criticalNotifyLabResultSuccess, criticalNotifyLabResultFailure, resetCriticalNotifyLabResult,
    confirmContactLabResultRequest, confirmContactLabResultSuccess, confirmContactLabResultFailure, resetConfirmContactLabResult,
} = slice.actions;

export default slice.reducer;
